module.exports = __webpack_public_path__ + "static/media/logo_telephysio.0555602c.png";